import { Component, ViewChild } from '@angular/core';
import { ModalSwipeDirective } from '../../../../shared/directives/modal-swipe/modal-swipe.directive';
import { BreakpointService } from '../../../../shared/services/breakpoint.service';
import { OverlaySwipeDirective } from '../../../../shared/directives/modal-swipe/overlay-swipe.directive';
import { BottomSwipeSheetDirective } from '../../../../shared/directives/modal-swipe/bottom-swipe-sheet.directive';
import { AsyncPipe, NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { map, Observable } from 'rxjs';
import { ConfigRepository } from '../../../../shared/repositories/config.repository';
import { CustomerProfileDto } from '../../../../api/v1/models/customer-profile-dto';
import { CustomerRepository } from '../../../../shared/repositories/customer.repository';
import { RouterLink } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';
import { FreshAuthPageComponent } from '../../fresh-auth-page/fresh-auth-page.component';
import { OutletOpenHours } from '../../../../shared/interfaces/outlet-open-hours';
import { AdditionalPageShortDto } from '../../../../api/v1/models/additional-page-short-dto';
import { LangSwitchComponent } from '../header/lang-switch/lang-switch.component';
import { LangSwitchToggleDirective } from '../header/lang-switch/lang-switch-toggle.directive';
import { LangSwitchTextDirective } from '../header/lang-switch/lang-switch-text.directive';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  imports: [
    NgIf,
    NgFor,
    NgClass,
    RouterLink,
    AsyncPipe,
    MatRadioModule,
    NgOptimizedImage,
    ModalSwipeDirective,
    BottomSwipeSheetDirective,
    OverlaySwipeDirective,
    FreshAuthPageComponent,
    LangSwitchComponent,
    LangSwitchToggleDirective,
    LangSwitchTextDirective,
  ],
  standalone: true
})
export class MobileMenuComponent {
  constructor (
    private configRepository: ConfigRepository,
    private customerRepository: CustomerRepository,
    public breakPoint: BreakpointService,
  ) {}

  isBasketMode$: Observable<boolean> = this.configRepository.isBasketMode$;
  customerProfile$: Observable<CustomerProfileDto | null> = this.customerRepository.customerProfile$;
  logoUrl$: Observable<string | undefined | null> = this.configRepository.logoUrl$;
  pageAbout$: Observable<AdditionalPageShortDto | undefined> =  this.configRepository.additionalAbout$;
  pagePrivacy$: Observable<AdditionalPageShortDto | undefined> = this.configRepository.additionalPrivacy$;
  isLoyalty$: Observable<boolean> = this.configRepository.isLoyalty$;
  pagePromoActions$: Observable<boolean> = this.configRepository.promotionCount$.pipe(
    map(count => !!count)
  );
  additionalPages$ = this.configRepository.additionalPages$;
  phone$: Observable<string | null> = this.configRepository.phone$;
  workingHours$: Observable<OutletOpenHours | null> = this.configRepository.workingHours$;

  brandName: string = environment.brandName;

  isShowModal: boolean = false;
  isShowAuth: boolean = false;

  @ViewChild(ModalSwipeDirective) modalSwipe: ModalSwipeDirective;

  onRedirect(): void {
    this.modalSwipe.hideModal();
  }

  onOpenModal(): void {
    this.isShowModal = true;
  }

  onCloseModal(): void {
    this.modalSwipe.hideModal();
    setTimeout(() => {
      this.isShowModal = false;
    }, 300);
  }

  onCloseAuth(): void {
    setTimeout(() => {
      this.isShowAuth = false;
    }, 150);
  }
}
